import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'

// Wrapper for the entire date picker
export const DatePicker = styled('div')({
  borderRadius: '3px',
})

// Styled input inside the TextField
export const StyledTextField = styled(TextField)<{ size?: 'small' | 'medium' }>(
  ({ size = 'medium' }) => ({
    '& .MuiInputBase-input': {
      paddingTop: size === 'small' ? '9px' : '15px',
      paddingBottom: size === 'small' ? '9px' : '14px',
    },
  })
)
